import { Sparkles } from "lucide-react";
import arcs from "@/assets/hero/arcs.png";
import phone from "@/assets/hero/phone.png";
import cardItalian from "@/assets/hero/card-italian.png";
import cardConversion from "@/assets/hero/card-conversion.png";
import cardSuggestions from "@/assets/hero/card-suggestions.png";
import cardLaptop from "@/assets/hero/card-laptop.png";

const HeroSection = () => {


  return (
    <section className="relative overflow-hidden pt-16">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-hero" />
        <div className="absolute inset-0 bg-grid-fade" />
        <div className="absolute -top-20 -left-20 w-[500px] h-[500px] rounded-full bg-[hsl(250_70%_56%/0.10)] blur-[100px] animate-breathe" />
        <div className="absolute -bottom-20 -right-20 w-[450px] h-[450px] rounded-full bg-[hsl(172_66%_50%/0.08)] blur-[100px] animate-breathe-delayed" />
      </div>

      <div className="section-container relative z-10 pt-12 lg:pt-16">
        <div className="mx-auto max-w-5xl text-center">
          <h1 className="animate-hero-fade text-3xl font-extrabold leading-[1.1] tracking-tight text-foreground sm:text-4xl md:text-5xl lg:text-[3.5rem]">
            <span className="block">Commerce is going <span className="text-gradient">Agentic</span></span>
            <span className="block">Your next customer will be an <span className="text-gradient">AI Agent</span></span>
          </h1>

          <p className="animate-hero-fade-d2 mx-auto mt-6 max-w-2xl text-base font-normal leading-relaxed text-muted-foreground sm:text-lg">
            AI agents are reshaping demand, discoverability and fulfillment.
            We help organizations act now and become agent-ready.
          </p>

          <div className="animate-hero-fade-d3 mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
            <a
              href="/your-growth-canvas"
              className="inline-flex items-center gap-2 rounded-full bg-gradient-primary px-8 py-3.5 text-base font-semibold text-primary-foreground transition-all hover:opacity-90 shadow-lg focus:outline-none focus:ring-2 focus:ring-primary/40 focus:ring-offset-2"
            >
              <Sparkles className="h-5 w-5" aria-hidden="true" />
              Get your Growth Canvas
            </a>
            <a
              href="/services"
              className="rounded-full border border-border bg-background/70 backdrop-blur px-6 py-3.5 text-base font-semibold text-foreground transition-all hover:bg-background hover:border-primary/40 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:ring-offset-2"
            >
              Our services
            </a>
          </div>
        </div>

        {/* Hero composition — all elements aligned to bottom baseline */}
        <div className="animate-hero-fade-d3 relative mx-auto mt-8 w-full max-w-5xl h-[300px] sm:h-[330px] md:h-[360px]">
          {/* Concentric arcs backdrop */}
          <img
            src={arcs}
            alt=""
            aria-hidden="true"
            width="520"
            height="360"
            loading="lazy"
            fetchPriority="low"
            className="absolute left-1/2 bottom-0 w-[520px] max-w-[85%] -translate-x-1/2 select-none pointer-events-none opacity-90"
          />

          {/* Phone center */}
          <img
            src={phone}
            alt="AI agent answering 'Suggest a good supplier for my Asian restaurant' on a smartphone"
            width="170"
            height="340"
            loading="eager"
            decoding="async"
            fetchPriority="high"
            className="absolute left-1/2 bottom-0 -translate-x-1/2 h-[280px] sm:h-[310px] md:h-[340px] w-auto drop-shadow-2xl"
          />

          {/* Top-left: Italian search */}
          <img
            src={cardItalian}
            alt="Voice query: Search for Italian restaurant near me — Bella Pasta, 4.5 stars"
            width="210"
            height="120"
            loading="lazy"
            decoding="async"
            className="hidden sm:block absolute bottom-[158px] sm:bottom-[173px] md:bottom-[188px] left-[2%] w-[210px] max-w-[22%] drop-shadow-xl motion-safe:animate-float-1"
          />

          {/* Top-right: AI conversion 40% */}
          <img
            src={cardConversion}
            alt="AI conversion rate metric: 40 percent"
            width="200"
            height="120"
            loading="lazy"
            decoding="async"
            className="hidden sm:block absolute bottom-[198px] sm:bottom-[218px] md:bottom-[238px] right-[2%] w-[200px] max-w-[20%] drop-shadow-xl motion-safe:animate-float-2"
          />

          {/* Bottom-left: AI suggestions pill */}
          <img
            src={cardSuggestions}
            alt="AI suggestions"
            width="130"
            height="80"
            loading="lazy"
            decoding="async"
            className="hidden sm:block absolute bottom-[48px] left-[16%] w-[130px] max-w-[14%] drop-shadow-xl motion-safe:animate-float-3"
          />

          {/* Bottom-right: Laptop stand searching */}
          <img
            src={cardLaptop}
            alt="Agent searching: Suggest laptop stand for this laptop"
            width="200"
            height="120"
            loading="lazy"
            decoding="async"
            className="hidden sm:block absolute bottom-[48px] right-[5%] w-[200px] max-w-[20%] drop-shadow-xl motion-safe:animate-float-4"
          />
        </div>
      </div>

    </section>
  );
};

export default HeroSection;
